import gettext from '@/i18n/gettext';

const { $gettext } = gettext;

/**
 * This helper is used to register gettext keys that cannot be registered directly.
 */

// Define I18n keys for error messages
const i18nKeys = {
  userDataError: $gettext('Could not fetch user data. Please try again later!'),
  internalServerError: $gettext(
    'Internal server error. Please try again later!',
  ),
  noRobotDataAvailable: $gettext(
    'No robot data have been collected yet. Please try again later!',
  ),
  invalidUserData: $gettext('Invalid user data. Please try again!'),
  invalidConfiguration: $gettext('Invalid configuration. Please try again!'),
  noRobotFoundForConfiguration: $gettext(
    'No robot configuration found for these requirements. Please try again!',
  ),
  noRevoluteJoint: $gettext('The given robot has no revolute joint'),
  couldNotDeterminePayload: $gettext('Could not determine payload.'),
  noTestTrajectoryKnownForTheConfiguration: $gettext(
    'No test trajectory known for the configuration.',
  ),
  robotCannotCarryAPayload: $gettext('Robot cannot carry a payload.'),
};

// Make sure they will be applied. Unfortunately, we cannot use the variables here as gettext won't
// recognize them this way.
$gettext('All');

$gettext('Healthy');
$gettext('Warning');
$gettext('Error');
$gettext('Unknown');

// this is used in the RobotFinder, but unfortunately in the HTML line there is a '//' prefixed
// so gettext thinks this is commented-out
$gettext('Price');

export default i18nKeys;
